import { render } from "./EditPricing.vue?vue&type=template&id=6045582c&scoped=true"
const script = {}

import "./../../../assets/styles/admin/pricingNav.scss?vue&type=style&index=0&id=6045582c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6045582c"]])

export default __exports__